import { type ExWindow, type LegalDocumentType } from '@ve/types';

declare let window: ExWindow;

// bug of old version of TS
// eslint-disable-next-line no-shadow
export enum storeModuleNames {
  MAP_FOR_ROUTES = 'mapForRoutes',
  ROUTES_PARAMS_STORE = 'routesParamsStore',
}

export const apiURL = '/';

export const endpoints = {
  intelligentSearch: 'intelligentSearch',
};

export const productTypes = {
  ALL: 'all',
  TOUR_OFFER: 'tourOffer',
  RAILWAY_TOUR: 'railwayTour',
  HOTEL_OFFER: 'hotelOffer',
};

export const operators = {
  MY_AGENT: [226, 299],
};

export function getLegalDocumentUrl(type: string): string {
  if (!type || window === undefined) {
    return '';
  }

  const legalDocuments = window.appConfig?.legalDocuments;
  if (!legalDocuments || typeof legalDocuments !== 'object') {
    return '';
  }
  return legalDocuments[type as LegalDocumentType] || '';
}

export function getFooterLinks() {
  return [
    { text: 'Политика о персональных данных', url: getLegalDocumentUrl('privacy') },
    { text: 'Политика использования файлов cookie', url: getLegalDocumentUrl('cookies_agreement') },
    { text: 'Пользовательское соглашение', url: getLegalDocumentUrl('user_agreement') },
    { text: 'Cогласие на обработку персональных данных', url: getLegalDocumentUrl('personal_data_agreement') },
    { text: 'На сайте применяются рекомендательные технологии', url: getLegalDocumentUrl('recommendation_technologies_agreement') },
    { text: 'Согласие на получение рекламы', url: getLegalDocumentUrl('consent_advertising') },
    { text: 'Согласие на распространение', url: getLegalDocumentUrl('personal_data_transfer_consent') },
    { text: 'Согласие посетителя', url: getLegalDocumentUrl('personal_data_visitor_consent') },
  ].filter(link => link.url);
}
